import { BOOKING_URL, SERVICES } from '../../lib/constants';
import { Clock, ArrowUpRight } from 'lucide-react';

export const Pricing = () => {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="section-pad bg-brand-bg relative"
    >
      <div className="container-prep">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-5">
            <p className="eyebrow mb-5">Pricing</p>
            <h2 data-testid="pricing-h2" className="heading-2">
              Lash lift pricing
              <span className="block italic text-brand-gold">in Vancouver.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-4">
            <p className="body-lg">
              Transparent, all-inclusive pricing. Every lash lift includes a
              complimentary tint. No hidden fees, no upsells — book the package
              that fits your lashes and your lifestyle.
            </p>
          </div>
        </div>

        <div className="bg-brand-bgElev rounded-3xl border border-brand-gold/15 overflow-hidden">
          {SERVICES.map((s, i) => (
            <a
              key={s.name}
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`pricing-row-${i}`}
              className={`group flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-6 sm:px-10 py-6 sm:py-8 transition-colors hover:bg-brand-bgSoft ${
                i !== SERVICES.length - 1 ? 'border-b border-brand-gold/10' : ''
              }`}
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 flex-wrap">
                  <h3 className="font-serif text-xl sm:text-2xl text-brand-cream group-hover:text-brand-gold transition-colors">
                    {s.name}
                  </h3>
                  {s.featured && (
                    <span className="text-[10px] uppercase tracking-[0.22em] bg-brand-gold/15 text-brand-gold px-2 py-0.5 rounded-full font-semibold border border-brand-gold/30">
                      Popular
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-1.5 mt-1.5 text-sm text-brand-muted">
                  <Clock size={13} /> {s.duration}
                </div>
              </div>
              <div className="flex items-center gap-6 sm:gap-8">
                <div className="font-serif text-3xl sm:text-4xl text-brand-gold leading-none">
                  ${s.price}
                </div>
                <ArrowUpRight
                  size={20}
                  className="text-brand-muted group-hover:text-brand-gold group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                />
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="pricing-book-cta"
            className="btn-primary"
          >
            Book Your Lash Lift Online →
          </a>
          <span className="text-sm text-brand-muted">or call 604-764-6452</span>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
